import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-1de41e86"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "fr-notice__panel",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
    key: 0,
    class: "fr-notice__sec"
};
const _hoisted_4 = { class: "fr-notice__title" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 1,
    class: "fr-notice__sec"
};
const _hoisted_7 = { class: "fr-notice__title" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "fr-notice__foot" };
import { computed, ref, watch } from 'vue';
import { t } from '@vue/services/interval-lang';
const STORAGE_KEY = '@fondueretro:notice-seen';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NoticeModal',
    props: {
        instruction: {},
        notice: {},
        active: { type: Boolean }
    },
    setup(__props) {
        /**
         * 訂位須知彈窗。
         *
         * 客人選完門市與時間、進入填資料頁時跳一次，讓須知在**下訂之前**就看到，
         * 而不是訂完才在確認信裡發現規則。
         *
         * ## 內容來源與回退
         * 門市各自可以有自己的須知；沒填就吃品牌層（門市決策，2026-08-20 確認）。
         * 兩段都空就整個不顯示 —— 露出一個空白視窗比不跳更糟。
         *
         * ## 只跳一次
         * 記在 sessionStorage：客人在填資料途中重整、或回上一步再進來，
         * 不該每次都被同一段文字擋一次。關掉分頁就重置。
         */
        const props = __props;
        const open = ref(false);
        const hasContent = computed(() => (props.instruction || '').trim() !== '' || (props.notice || '').trim() !== '');
        watch(() => props.active, (isActive) => {
            if (!isActive || !hasContent.value) {
                return;
            }
            try {
                if (sessionStorage.getItem(STORAGE_KEY)) {
                    return;
                }
                sessionStorage.setItem(STORAGE_KEY, '1');
            }
            catch {
                // 無痕模式等情境下 sessionStorage 會丟例外：讓它照跳，不要因此擋掉須知
            }
            open.value = true;
        }, { immediate: true });
        function close() {
            open.value = false;
        }
        return (_ctx, _cache) => {
            return (open.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fr-notice",
                    onClick: _withModifiers(close, ["self"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "fr-notice__close",
                            "aria-label": _unref(t)('common.close'),
                            onClick: close
                        }, "×", 8, _hoisted_2),
                        ((_ctx.instruction || '').trim())
                            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                                _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('bk.noticeInstruction')), 1),
                                _createElementVNode("div", {
                                    class: "fr-notice__body",
                                    innerHTML: _ctx.instruction
                                }, null, 8, _hoisted_5)
                            ]))
                            : _createCommentVNode("", true),
                        ((_ctx.notice || '').trim())
                            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                                _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)('bk.noticeReminder')), 1),
                                _createElementVNode("div", {
                                    class: "fr-notice__body",
                                    innerHTML: _ctx.notice
                                }, null, 8, _hoisted_8)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "fr-btn",
                                onClick: close
                            }, _toDisplayString(_unref(t)('common.gotIt')), 1)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
